/* ==========================================================================
   Piss Missile — ads landing page behaviour
   Offer tier state, sticky buy bar, scroll reveals, theme toggle, anchors.

   All money strings and the variant id are rendered by Liquid from the live
   product, so this file never hardcodes a price or an id. It only mirrors the
   selected tier into the real /cart/add form inputs.
   ========================================================================== */
(function () {
  'use strict';

  // Every section links this file so the page still works if the merchant
  // removes one. Guard against double-binding when several are present.
  if (window.__pmLpInit) return;
  window.__pmLpInit = true;

  var root = document.documentElement;

  /* ---------- Offer tiers -> real cart form inputs ---------- */
  var offer = document.querySelector('[data-pm-offer]');
  var tiers = document.querySelectorAll('input[name="pm-tier"]');

  function money(cents, sample) {
    // Mirror the store's own money format, taken from a Liquid-rendered sample
    // like "$1,234.56" so we keep the right symbol and separators.
    var n = (cents / 100).toFixed(2);
    var m = /^([^\d]*)[\d.,]+([^\d]*)$/.exec(sample || '$0.00');
    var pre = m ? m[1] : '$';
    var post = m ? m[2] : '';
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return pre + parts.join('.') + post;
  }

  function selectedTier() {
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].checked) return tiers[i];
    }
    return tiers.length ? tiers[0] : null;
  }

  function setText(sel, value) {
    var nodes = document.querySelectorAll(sel);
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = value;
  }

  function syncTier() {
    var t = selectedTier();
    if (!t) return;

    var qty = t.getAttribute('data-qty');
    var totalCents = parseInt(t.getAttribute('data-total-cents'), 10);
    var wasCents = parseInt(t.getAttribute('data-was-cents'), 10);
    var sample = (offer && offer.getAttribute('data-money-sample')) || '$0.00';

    // Mirror quantity into every real cart form on the page.
    var qtyInputs = document.querySelectorAll('input.pm-qty');
    for (var i = 0; i < qtyInputs.length; i++) qtyInputs[i].value = qty;

    setText('[data-pm-cta-text]', t.getAttribute('data-cta'));
    setText('[data-pm-bar-label]', t.getAttribute('data-label'));
    setText('[data-pm-bar-price]', money(totalCents, sample));

    var wasNodes = document.querySelectorAll('[data-pm-bar-was]');
    for (var k = 0; k < wasNodes.length; k++) {
      if (wasCents > totalCents) {
        wasNodes[k].textContent = money(wasCents, sample);
        wasNodes[k].hidden = false;
      } else {
        wasNodes[k].textContent = '';
        wasNodes[k].hidden = true;
      }
    }

    // Free-shipping progress note.
    var note = document.querySelector('[data-pm-ship-note]');
    if (note) {
      var min = parseInt(note.getAttribute('data-threshold-cents'), 10);
      if (isNaN(min) || min <= 0) {
        note.setAttribute('data-unlocked', 'true');
      } else {
        var free = totalCents >= min;
        note.setAttribute('data-unlocked', free ? 'true' : 'false');
        setText(
          '[data-pm-ship-text]',
          free
            ? note.getAttribute('data-unlocked-text')
            : note
                .getAttribute('data-locked-text')
                .replace('[amount]', money(min - totalCents, sample))
        );
      }
    }
  }

  for (var a = 0; a < tiers.length; a++) {
    tiers[a].addEventListener('change', syncTier);
  }
  syncTier();

  /* ---------- Sticky buy bar ----------
     Shows once the reader is past the hero, hides while the offer block (which
     has its own button) is on screen. */
  var bar = document.querySelector('[data-pm-buybar]');
  if (bar) {
    var hero = document.querySelector('.hero');
    var pastHero = false;
    var overOffer = false;

    function paintBar() {
      bar.setAttribute('data-show', pastHero && !overOffer ? 'true' : 'false');
    }

    function onScroll() {
      var trigger = hero ? hero.offsetTop + hero.offsetHeight * 0.75 : 600;
      pastHero = (window.pageYOffset || root.scrollTop) > trigger;
      paintBar();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    if ('IntersectionObserver' in window && offer) {
      new IntersectionObserver(
        function (entries) {
          overOffer = entries[0].isIntersecting;
          paintBar();
        },
        { threshold: 0.3 }
      ).observe(offer);
    }
  }

  /* ---------- Scroll reveals ---------- */
  var revealables = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var ro = new IntersectionObserver(
      function (entries) {
        for (var n = 0; n < entries.length; n++) {
          if (entries[n].isIntersecting) {
            entries[n].target.classList.add('in');
            ro.unobserve(entries[n].target);
          }
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    for (var r = 0; r < revealables.length; r++) ro.observe(revealables[r]);
  } else {
    for (var r2 = 0; r2 < revealables.length; r2++) revealables[r2].classList.add('in');
  }

  /* ---------- Light / dark toggle ---------- */
  var SUN =
    '<circle cx="12" cy="12" r="4.5"/><path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.2 5.2l1.4 1.4M17.4 17.4l1.4 1.4M18.8 5.2l-1.4 1.4M6.6 17.4l-1.4 1.4"/>';
  var MOON = '<path d="M20 14.5A8.5 8.5 0 019.5 4a8.5 8.5 0 1010.5 10.5z"/>';

  var startDark = !(window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches);
  var theme = startDark ? 'dark' : 'light';
  var icon = document.getElementById('pm-theme-icon');

  function applyTheme() {
    root.setAttribute('data-pm-theme', theme);
    if (icon) icon.innerHTML = theme === 'dark' ? SUN : MOON;
  }
  applyTheme();

  var toggle = document.getElementById('pm-theme-toggle');
  if (toggle) {
    toggle.addEventListener('click', function () {
      theme = theme === 'dark' ? 'light' : 'dark';
      applyTheme();
    });
  }

  /* ---------- Hide the Smile.io rewards launcher on this page only ----------
     Smile is a site-wide app embed with no per-page control, and it injects its
     launcher asynchronously into <body> under ids that change between versions,
     so a stylesheet alone can miss it. This watches for any top-level node that
     Smile owns and hides it. It only ever runs on this template, because only
     this template loads this file, so other pages keep the widget.
     Nodes are hidden rather than removed so the app's own scripts never error. */
  function hidePmSmile(node) {
    if (!node || node.nodeType !== 1) return;
    var name = (node.id || '') + ' ' + (typeof node.className === 'string' ? node.className : '') +
               ' ' + node.tagName.toLowerCase();
    if (name.toLowerCase().indexOf('smile') === -1) return;
    if (node.style.display !== 'none') node.style.setProperty('display', 'none', 'important');
  }

  function sweepPmSmile() {
    var kids = document.body ? document.body.children : [];
    for (var s = 0; s < kids.length; s++) hidePmSmile(kids[s]);
  }

  sweepPmSmile();
  if (window.MutationObserver && document.body) {
    new MutationObserver(function (records) {
      for (var m = 0; m < records.length; m++) {
        var added = records[m].addedNodes;
        for (var n = 0; n < added.length; n++) hidePmSmile(added[n]);
      }
    }).observe(document.body, { childList: true });
  }

  /* ---------- Anchor scroll that clears the sticky header ---------- */
  var anchors = document.querySelectorAll('a[href^="#"]');
  for (var q = 0; q < anchors.length; q++) {
    anchors[q].addEventListener('click', function (ev) {
      var id = this.getAttribute('href');
      if (!id || id.length < 2) return;
      var target = document.querySelector(id);
      if (!target) return;
      ev.preventDefault();
      var offsetPx = target.id === 'pm-top' ? 0 : 68;
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.pageYOffset - offsetPx,
        behavior: 'smooth',
      });
    });
  }
})();
